import { useBemCN } from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { Layout } from "@gik/ui-legacy/gik/Layout/Layout";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import React from "react";
import { BlogCard } from "../components/BlogCard";
import type { LandingPageBlogPost } from "../types/LandingPageBlogPost";

export interface IBlogSectionProps {
	mainPost?: LandingPageBlogPost;
	posts: LandingPageBlogPost[];
}

/**
 * https://www.figma.com/design/FT2ninjhNiQOXfnOTaZfqy/%F0%9F%91%A8%F0%9F%8F%BC%E2%80%8D%F0%9F%8E%A4-Jade's-workspace-of-asset-creation?node-id=4696-8640&m=dev
 */
function BlogSectionComp({ mainPost, posts }: IBlogSectionProps) {
	const bem = useBemCN("blog-section");

	const splitPosts = posts.reduce((acc, post, i) => {
		const index = Math.floor(i / 3);
		if (!acc[index]) {
			acc[index] = [];
		}
		acc[index].push(post);
		return acc;
	}, []);

	return (
		<PageSection
			asElement={"section"}
			largePadding
			{...bem(null, null, "!tw-pb-8 !tw-pt-20 !md:tw-pb-20")}
		>
			<Layout
				direction={"column"}
				align={"start"}
				perpendicular={"center"}
				gap={16}
			>
				<h2 className={blogTitleClassNames.join(" ")}>Our Blog</h2>
				<Layout direction={"column md:row"} gap={8}>
					{mainPost && (
						<BlogCard
							post={mainPost}
							style={{
								flex: `0 0 ${100 / 3}%`,
							}}
						/>
					)}

					{splitPosts.map((posts, i) => (
						<React.Fragment key={i}>
							<Layout direction={"column"} gap={8} flex={`0 0 ${100 / 3}%`}>
								{posts.map((post, i) => (
									<BlogCard key={i} post={post} />
								))}
							</Layout>
						</React.Fragment>
					))}
				</Layout>
			</Layout>
		</PageSection>
	);
}

export const BlogSection = withComponentErrorBoundary(BlogSectionComp);

const blogTitleClassNames = [
	"tw-m-0",
	"tw-font-heading",
	"tw-text-4xl",
	"tw-font-semibold",
	"tw-text-neutral-900",
	"tw-text-center",

	"md:tw-text-center",
	"md:tw-font-heading",
	"md:tw-text-5xl",
	"md:tw-leading-tight",
];
